// @flow
import * as React from 'react';
import BSButton from 'react-bootstrap/lib/Button';
import BSButtonGroup from 'react-bootstrap/lib/ButtonGroup';
import classNames from 'classnames';
import isEqual from 'react-fast-compare';
import styles from './ButtonGroup.module.scss';

type Button = {
    className: string,
    id: string,
    label: React.Node,
    primary: string,
    selected: boolean,
};

type Props = {
    buttons: Button[],
};

const ButtonGroup = ({ buttons }: Props) => {
    const groupOfButtons = buttons.map(button => {
        const { className, label, id, selected } = button;
        const classesPrep = [styles.button];
        if (selected) {
            button.primary = (!selected).toString();
            classesPrep.push(styles['button-selected']);
        }
        const classes = classNames(classesPrep, className);
        return (
            <BSButton {...button} key={id} className={classes}>
                {label}
            </BSButton>
        );
    });

    return <BSButtonGroup>{groupOfButtons}</BSButtonGroup>;
};

export default React.memo<Props>(ButtonGroup, isEqual);
